import { useQuery } from "@apollo/client/react";

import { getGroups } from "src/allocation/graphql/team.graphql";

type GroupsQuery = {
  groups?: { id?: string | null; name?: string | null }[] | null;
};

/** Name for the selected inbox team tag. Falls back to the id until the lookup lands, and for unknown/deleted teams. */
export const useInboxTeamName = (teamId: string | null): string | null => {
  const { data } = useQuery<GroupsQuery>(getGroups, {
    skip: teamId == null,
    variables: { groupIds: teamId ? [teamId] : [] },
  });
  if (teamId == null) {
    return null;
  }
  const name = data?.groups?.find((group) => group.id === teamId)?.name;
  return name && name !== "" ? name : teamId;
};
